import { checkLink, spinTheWheel, storePhone, uploadPhoto } from "@/api/participation";
import { defineStore } from "pinia";

export const useParticipationStore = defineStore('participationStore', {
    state: () => ({
        link: null,
        gifts: [],
        participation: null,
        form: {
            phone: null,
            photo: null,
            previewPhoto: null
        }
    }),
    actions: {
        async checkLink() {

            try {
                const response = await checkLink(this.link);
                console.log('check link :>> ', response);
                if (response.data.success) {

                    this.link = response.data.data.participation.link;
                    this.gifts = response.data.data.gifts;
                    this.participation = response.data.data.participation;
                    this.gift = response.data.data.participation.gift_id ? this.gifts.find(g => g.id === response.data.data.participation.gift_id) : null;


                    return {
                        success: true,
                        data: response.data
                    }
                }
            } catch (error) {
                console.log('error :>> ', error);

                return {
                    success: false,
                    message: "not_valid_link"
                }
            }
        },
        async submitPhone(phone) {
            try {
                const response = await storePhone(phone);
                console.log('response submit phone :>> ', response);

                if (response.data.success) {
                    this.link = response.data.data.link;
                    this.participation = response.data.data.participation;
                    this.gifts = response.data.data.gifts;

                    return {
                        success: true,
                    }
                }
                return {
                    success: false,
                    message: "not_valid_phone"
                }

            } catch (error) {
                console.log('error :>> ', error.response.data.errors.phone[0]);

                return {
                    success: false,
                    message: error.response.data.errors.phone[0]
                }
            }
        },
        async submitPhoto() {

            try {

                const response = await uploadPhoto({
                    photo: this.form.photo,
                    link: this.link
                });



                if (response.data.success) {
                    // this.link = response.data.data.link;
                    // this.participation = response.data.data.participation;

                    return {
                        success: true,
                        already_has_valid_photo: response.data.already_has_valid_photo ?? false
                    }
                }


                if (response.data.errors.photo) {
                    return {
                        success: false,
                        message: response.data.message.photo[0]
                    }
                }


            } catch (error) {
                if (error.response.data.message?.photo) {
                    return {
                        success: false,
                        message: error.response.data.message.photo[0]
                    }
                }

                console.log('error :>> ', error);
                return {
                    success: false,
                    message: error.response.data.message
                }
            }
        },
        async spinTheWheel() {
            try {
                const response = await spinTheWheel({ link: this.link });

                if (response.data.success) {
                    this.participation = response.data.data.participation;
                    return { success: true };
                }

                return {
                    success: false,
                    message: response.data.message || "unknown_error"
                };

            } catch (error) {

                const resp = error.response?.data;

                if (resp?.errors) {
                    const firstField = Object.keys(resp.errors)[0];
                    const firstErrorMsg = resp.errors[firstField]?.[0] || "invalid_request";
                    return { success: false, message: firstErrorMsg };
                }

                if (resp?.message) {
                    return { success: false, message: resp.message };
                }

                return { success: false, message: "unknown_error" };
            }
        },
        resetStore() {
            this.link = null;
            this.gifts = []; this.participation = null;
            this.form = {
                phone: null,
                photo: null,
                previewPhoto: null
            }
        }
        ,
        updateParticipationPhotoData(data) {
            this.participation = data.participation;
        }
    }
}
)